import { useReduxState } from 'hooks';
import { App } from 'components/app';
import { Header, SubHeader } from 'components/header';
import { PageFooter, PageServiceDisruptionInfo } from '.';

import { CSSProperties } from 'react';

interface Props {
  appError?: boolean;
  activePathname?: string;
  appStyle?: CSSProperties;
  backgroundColor?: string;
  backgroundImage?: string;
  backgroundPosition?: string;
  children: React.ReactNode;
  header?: boolean;
  onHelpClick?: () => void;
  pageContentStyle?: CSSProperties;
  showLoginFooter?: boolean;
  showUser?: boolean;
  subheader?: boolean;
}

const Page = ({
  appError = false,
  activePathname,
  appStyle,
  backgroundColor,
  backgroundImage,
  backgroundPosition,
  children,
  header = true,
  onHelpClick,
  pageContentStyle,
  showLoginFooter,
  showUser = true,
  subheader = true
}: Props) => {
  const {
    pageState: { isReader },
    serverConfig,
    theme
  } = useReduxState();

  return (
    <App appError={appError} appStyle={appStyle}>
      <PageServiceDisruptionInfo />

      {header ? (
        <Header
          onHelpClick={onHelpClick}
          showBoxShadow={!isReader && !subheader}
          showUser={showUser}
        />
      ) : null}

      {subheader ? <SubHeader activeLink={activePathname} /> : null}

      <main className="page-content" style={pageContentStyle}>
        {children}

        <style jsx>{`
          .page-content {
            background: ${backgroundImage
              ? `url(${backgroundImage}) ${
                  backgroundPosition || '0% 0%'
                } / cover no-repeat fixed`
              : 'none'};
            background-color: ${backgroundColor || theme.pageBackgroundColor};
            flex-grow: 1;
            position: relative;
          }
        `}</style>
      </main>

      {showLoginFooter &&
      (serverConfig?.footerLoginContent ||
        serverConfig?.footerContent ||
        serverConfig?.footerLoginShowVuolearningTerms) ? (
        <PageFooter
          footerContent={
            serverConfig?.footerLoginContent || serverConfig?.footerContent
          }
          showAdditionalTerms={serverConfig?.footerLoginShowAdditionalTerms}
          showVuolearningTerms={serverConfig?.footerLoginShowVuolearningTerms}
        />
      ) : serverConfig?.footerContent ? (
        <PageFooter footerContent={serverConfig?.footerContent} />
      ) : null}
    </App>
  );
};

export default Page;
